import React, { useState, useCallback } from "react";
import StatefulButton from "src/components/common/stateful-button";
import { useStoreActions } from "src/store";
import { deleteOpenShift } from "src/api";

interface IProps {
  eventId: string;
  handleClose: () => void;
}

const DeleteOpenShift: React.FC<IProps> = (props) => {
  const { eventId, handleClose } = props;
  const [loading, setLoading] = useState(false);

  const removeOpenShift = useStoreActions(
    (actions) => actions.shifts.removeOpenShift
  );

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      await deleteOpenShift(eventId);
      // We can now store the shift locally
      removeOpenShift(eventId);
      handleClose();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [eventId, handleClose, removeOpenShift]);

  return (
    <>
      <p>Are you sure you want to delete this open shift?</p>
      <div className="d-flex align-items-center justify-content-between mt-2">
        <StatefulButton
          color="danger"
          onClick={handleDelete}
          className="ml-auto"
          loading={loading}
        >
          Delete
        </StatefulButton>
      </div>
    </>
  );
};

export default DeleteOpenShift;
